import React, { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Button,
  Box,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  TextField,
} from "@mui/material";
import roundClearAll from "@iconify/icons-ic/round-clear-all";
import { get_root_value } from "src/utils/domUtils";
import { Icon } from "@iconify/react";
import { form_filter_data } from "src/DAL/Programme/Programme";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { useEffect } from "react";
import MUIAutocomplete from "src/components/GeneralComponents/MUIAutocomplete";

export default function UserFormFilter({
  filterData,
  handleSelectOther,
  searchFunction,
  handleClearFilter,
}) {
  const [programsList, setProgramsList] = useState([]);
  const [personName, setPersonName] = useState([]);
  const [coachesListing, setCoachesListing] = useState([]);
  const [serchText, setSerchText] = useState("");

  const getMemberList = (data) => {
    let member = data.map((data) => {
      let full_name =
        data.first_name + " " + data.last_name + " (" + data.email + ")";
      return {
        full_name,
        _id: data._id,
        chip_label: `Member: ${full_name}`,
        chip_value: data._id,
      };
    });
    setPersonName(member);
  };

  const getCoachList = (data) => {
    let coach = data.map((data) => {
      let full_name =
        data.first_name + " " + data.last_name + " (" + data.email + ")";
      return {
        full_name,
        _id: data._id,
        chip_label: `Coach: ${full_name}`,
        chip_value: data._id,
      };
    });
    setCoachesListing(coach);
  };

  const getProgList = (data) => {
    let program = data.map((data) => {
      return {
        title: data.title,
        _id: data._id,
        chip_label: `Program: ${data.title}`,
        chip_value: data._id,
      };
    });
    setProgramsList(program);
  };

  const goalsLevel = [
    {
      name: "Submitted",
      value: "submitted",
    },
    {
      name: "Pending",
      value: "pending",
    },
  ];

  const get_data_list = async (type, search_text) => {
    let search = search_text || "";
    const result = await form_filter_data(type, search);
    if (result.code === 200) {
      if (type === "coach") {
        getCoachList(result?.coach_list);
      } else if (type === "member") {
        getMemberList(result?.member);
      } else if (type === "program") {
        getProgList(result?.program);
      }
    }
  };

  useEffect(() => {
    if (filterData.receiver_type) {
      get_data_list(filterData.receiver_type, serchText);
    }
  }, [filterData.receiver_type, serchText]);

  useEffect(() => {
    setSerchText("");
  }, [filterData.receiver_type]);

  return (
    <>
      <div className="container new-memories px-4">
        <FormControl fullWidth className="mt-3">
          <InputLabel id="demo-simple-select-label">Form type</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="Form type"
            value={filterData.receiver_type}
            label="Form type"
            onChange={(e) => handleSelectOther("receiver_type", e.target.value)}
          >
            <MenuItem value="coach">Coach</MenuItem>
            <MenuItem value="member"> Member</MenuItem>
            <MenuItem value="program">Program</MenuItem>
          </Select>
        </FormControl>
        {filterData.receiver_type === "coach" ? (
          <div className="mt-3">
            <MUIAutocomplete
              inputLabel="Coach"
              selectedOption={filterData.send_to}
              setSelectedOption={(e) => {
                handleSelectOther("send_to", e);
              }}
              optionsList={coachesListing}
              setCustomSearch={setSerchText}
              name="full_name"
            />
          </div>
        ) : filterData.receiver_type === "member" ? (
          <div className="mt-3">
            <MUIAutocomplete
              inputLabel="Member"
              selectedOption={filterData.send_to}
              setSelectedOption={(e) => {
                handleSelectOther("send_to", e);
              }}
              optionsList={personName}
              setCustomSearch={setSerchText}
              name="full_name"
            />
          </div>
        ) : filterData.receiver_type === "program" ? (
          <div className="mt-3">
            <MUIAutocomplete
              inputLabel="Program"
              selectedOption={filterData.program}
              setSelectedOption={(e) => {
                handleSelectOther("program", e);
              }}
              optionsList={programsList}
              setCustomSearch={setSerchText}
              name="title"
            />
          </div>
        ) : (
          ""
        )}
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterData.filter_by_dates}
                onChange={(e) => {
                  handleSelectOther("filter_by_dates", e.target.checked);
                }}
              />
            }
            label="Search By Date Range"
          />
          {filterData.filter_by_dates && (
            <>
              <div className="col-12 mt-3">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Start Date *"
                    name="date_from"
                    inputFormat="dd-MM-yyyy"
                    value={filterData.date_from}
                    onChange={(e) => {
                      handleSelectOther("date_from", e);
                    }}
                    required
                    format="DD-MM-YYYY"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="inputs-fields"
                        fullWidth
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-12 mt-3">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="End Date *"
                    name="date_to"
                    value={filterData.date_to}
                    inputFormat="dd-MM-yyyy"
                    required
                    onChange={(e) => {
                      handleSelectOther("date_to", e);
                    }}
                    format="DD-MM-YYYY"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="inputs-fields"
                        fullWidth
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </>
          )}
        </>
        <Box sx={{ py: 2 }}>
          <Button
            fullWidth
            size="large"
            type="submit"
            color="inherit"
            variant="outlined"
            onClick={searchFunction}
            startIcon={
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 5 }}
              >
                <path
                  d="M13.1165 0.25H0.883548C0.321452 0.25 0.0378205 0.932013 0.436097 1.33029L5.3125 6.20743V11.6406C5.3125 11.8471 5.41325 12.0406 5.58242 12.1591L7.69179 13.6351C8.10794 13.9264 8.6875 13.6312 8.6875 13.1167V6.20743L13.564 1.33029C13.9615 0.932804 13.6798 0.25 13.1165 0.25Z"
                  fill={get_root_value("--portal-theme-primary")}
                />
              </svg>
            }
          >
            Filter
          </Button>
        </Box>
        <Button
          fullWidth
          size="large"
          type="submit"
          color="inherit"
          variant="outlined"
          className="mb-3"
          onClick={handleClearFilter}
          startIcon={<Icon icon={roundClearAll} />}
        >
          Clear All
        </Button>
      </div>
    </>
  );
}
